
import React, { ReactNode } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import styles from '../styles/Layout.module.css';

interface DashboardLayoutProps {
    children: ReactNode;
    user: any;
    title?: string;
    systemStatus?: 'online' | 'offline' | 'warning';
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children, user, title, systemStatus }) => {
    return (
        <div className={styles.layout}>
            <Sidebar />
            <div className={styles.mainContent}>
                <TopBar user={user} title={title} systemStatus={systemStatus} />
                <main className={styles.contentBody}>
                    {children}
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
